import React, { useEffect, useState } from "react";
import Content from "../../../components/Contents/Content";
import { HandCoins } from "lucide-react";
import { useLocation, useNavigate } from "react-router-dom";
import { loadScript } from "../../../../Utils/Razorpayment";
import { AddBasketsubscription, getQRcodedata, getBankdetaildata, GetUserData, GetBasketService } from "../../../Services/UserService/User";
import { basicsettinglist } from "../../../Services/Admin/Admin";
import { image_baseurl } from "../../../../Utils/config";
import showCustomAlert from "../../../Extracomponents/CustomAlert/CustomAlert";
import Kyc from "../Profile/Kyc";
import ReusableModal from "../../../components/Models/ReusableModal";
import ReusableModal1 from "../../../components/Models/ReusableModal1";


const Payments = () => {

    const token = localStorage.getItem("token");
    const userid = localStorage.getItem("id");
    const navigate = useNavigate();
    const location = useLocation();
    const key = location?.state?.key;
    const { state } = useLocation()


    const stateItem = state?.item

    const [activeTab, setActiveTab] = useState(stateItem == "servicePageOfflinePayment" ? "offline" : "online");
    const [allKey, setAllKey] = useState([])
    const [bankdetail, setBankdetail] = useState([]);
    const [qrdata, setQrdata] = useState([]);
    const [userdata, setUserdata] = useState([]);
    const [kycStatus, setKycStatus] = useState("")
    const [viewmodel2, setViewModel2] = useState(false);
    const [viewmodel3, setViewModel3] = useState(false);
    const [basketdata, setBasketdata] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [currentItem, setCurrentItem] = useState(null);
    const [kyckey, setKyckey] = useState([])





    const getUrlPlanId = () => {
        const fullUrl = window.location.href;
        const queryString = fullUrl.split("?").slice(1).join("&");
        const searchParams = new URLSearchParams(queryString);
        return searchParams.get("planid");
    };

    useEffect(() => {
        getkeybydata()
        getQRimage()
        getbankdata()
        fetchUserData();
        getbasketdata();
    }, [])

    useEffect(() => {
        if (location.state?.key) {
            setActiveTab("offline");
        }
    }, [location.state?.key]);


    useEffect(() => {
        const urlPlanId = getUrlPlanId();

        if (stateItem) {
            setCurrentItem(stateItem);
        } else if (urlPlanId && basketdata.length > 0) {
            const matchedItem = basketdata.find(basket => basket._id === urlPlanId);
            if (matchedItem) {
                setCurrentItem(matchedItem);
            } else {
                showCustomAlert("error", "Invalid plan ID. Please select a valid plan.");
            }
        }
    }, [stateItem, basketdata]);



    const getbasketdata = async () => {
        try {
            const data = { clientid: userid };
            const response = await GetBasketService(data, token);
            if (response.status) {
                setBasketdata(response.data);
            }
        } catch (error) {
            console.log("error", error);
        }
        setIsLoading(false);
    };



    const handleShowModal = (item) => {
        if (kycStatus == 1 && (userdata?.kyc_verification == 0 || userdata?.kyc_verification == 2)) {
            setViewModel2(true)
            setKyckey(item._id)
        } else {
            AddbasketSubscribeplan(item)
        }
    };



    const fetchUserData = async () => {
        try {
            const userData = await GetUserData(userid, token);
            if (userData && userData.data) {
                setUserdata(userData.data)
            }
        } catch (error) {
            showCustomAlert("error", "Failed to load user data. Please refresh and try again.");
        }
    }


    const getQRimage = async () => {
        try {
            const response = await getQRcodedata();
            if (response.status) {
                setQrdata(response?.data)
            }
        } catch (error) {
            console.error("Error fetching coupons:", error);
        }
    };


    const getbankdata = async () => {
        try {
            const response = await getBankdetaildata();
            if (response.status) {
                setBankdetail(response?.data)
            }
        } catch (error) {
            console.error("Error fetching coupons:", error);
        }
    };



    const getkeybydata = async () => {
        try {
            const response = await basicsettinglist();
            if (response.status) {
                setAllKey(response.data[0])
                setKycStatus(response?.data[0].kyc)
            }
        } catch (error) {
            console.error("Error fetching coupons:", error);
        }
    };



    const AddbasketSubscribeplan = async (item) => {
        try {
            if (!window.Razorpay) {
                await loadScript("https://checkout.razorpay.com/v1/checkout.js");
            }

            const price = item?.basket_price;
            const finalAmount = Math.round(price * (1 + allKey?.gst / 100) * 100);

            const options = {
                key: allKey.razorpay_key,
                amount: finalAmount,
                name: allKey.from_name,
                currency: "INR",
                title: item?.title || "Subscription Basket",
                handler: async function (response1) {
                    const data = {
                        basket_id: item?._id,
                        client_id: userid,
                        price: finalAmount,
                        discount: 0,
                        orderid: response1?.razorpay_order_id || "",
                        coupon: "",
                    };

                    try {
                        const response2 = await AddBasketsubscription(data, token);
                        if (response2?.status) {
                            if (kycStatus == 2 && userdata?.kyc_verification == 0) {
                                setViewModel3(true);
                            } else {
                                navigate("/user/thankyou", {
                                    state: {
                                        planType: data,
                                    },
                                });
                            }
                        }
                    } catch (error) {
                        console.error("Error while adding plan subscription:", error);
                    }
                },
                prefill: {},
                theme: {
                    color: "#F37254",
                },
            };

            const rzp = new window.Razorpay(options);
            rzp.open();
        } catch (error) {
            console.error("Subscription error:", error);
        }
    };

    useEffect(() => {
        if (allKey?.paymentstatus === 0 && activeTab === "online") {
            setActiveTab("offline");
        }
    }, [allKey?.paymentstatus, activeTab]);

    // Show loading state if data is still being fetched
    if (isLoading) {
        return (
            <Content
                Page_title="Payment"
                button_title="Add Basket"
                backbutton_title="back"
                button_status={false}
                backbutton_status={false}
                backForword={true}
            >
                <div className="text-center">Loading...</div>
            </Content>
        );
    }


    if (!currentItem) {
        return (
            <Content
                Page_title="Payment"
                button_title="Add Basket"
                backbutton_title="back"
                button_status={false}
                backbutton_status={false}
                backForword={true}
            >
                <div className="text-center">
                    <p>No plan selected or invalid plan ID.</p>
                    <button
                        className="btn btn-primary"
                        onClick={() => navigate('/user/baskets')}
                    >
                        Select a Plan
                    </button>
                </div>
            </Content>
        );
    }

    return (
        <Content
            Page_title="Payment"
            button_title="Add Basket"
            backbutton_title="back"
            button_status={false}
            backbutton_status={false}
            backForword={true}
        >
            <ul className="nav nav-pills mb-3 justify-content-center border-bottom">
                {!key && allKey?.paymentstatus === 1 && stateItem !== "servicePageOfflinePayment" && (
                    <li className="nav-item">
                        <button
                            className={`nav-link ${activeTab === "online" ? "active btn-primary" : ""}`}
                            onClick={() => setActiveTab("online")}
                        >
                            Pay Online
                        </button>
                    </li>
                )}

                {allKey?.officepaymenystatus === 1 && (
                    <li className="nav-item">
                        <button
                            className={`nav-link ${activeTab === "offline" ? "active btn-primary" : ""}`}
                            onClick={() => setActiveTab("offline")}
                        >
                            Pay Offline
                        </button>
                    </li>
                )}
            </ul>

            {!key && activeTab === "online" && allKey?.paymentstatus === 1 && (
                <div className="row justify-content-center mt-4">
                    <div className="col-md-6">
                        <div className="card">
                            <div className="card-header text-white">
                                <HandCoins className="me-2 btn-primary p-1 rounded  " />
                                Your total saving is off ₹ {Number(currentItem?.full_price) - Number(currentItem?.basket_price)}
                            </div>
                            <div className="card-body">
                                <div className="d-md-flex justify-content-between py-2">
                                    <h6 className="card-title mb-0"><strong>Validity</strong></h6>
                                    <h6 className="card-title mb-0"><strong>{currentItem?.validity}</strong></h6>
                                </div>

                                {(allKey?.gststatus === 1 || allKey?.gststatus === 0) && (
                                    <div className="d-md-flex justify-content-between py-2">
                                        <h6 className="card-title mb-0"><strong>GST ({allKey?.gst}%{allKey?.gststatus === 0 ? " Inclusive" : ""})</strong></h6>
                                        <h6 className="card-title mb-0">
                                            <strong>₹ {(allKey?.gststatus === 1 
                                                ? (currentItem?.basket_price * allKey?.gst) / 100 
                                                : currentItem?.basket_price - (currentItem?.basket_price / (1 + Number(allKey?.gst) / 100))
                                            ).toFixed(2)}</strong>
                                        </h6>
                                    </div>
                                )}
                                <div className="d-md-flex justify-content-between py-2 pb-3">
                                    <h6 className="card-title mb-0"><strong>Grand Total</strong></h6>
                                    <h6 className="card-title mb-0">
                                        <strong>
                                            ₹ {(
                                                allKey?.gststatus === 1
                                                    ? currentItem?.basket_price + (currentItem?.basket_price * allKey?.gst) / 100
                                                    : currentItem?.basket_price
                                            ).toFixed(2)}
                                        </strong>
                                    </h6>
                                </div>

                                <button
                                    className="btn btn-success w-100"
                                    onClick={() => handleShowModal(currentItem)}
                                >
                                    Subscribe Now
                                    <span className="text-decoration-line-through text-light small mx-2">
                                        ₹ {currentItem?.full_price}
                                    </span>
                                    ₹ {(allKey?.gstStatus === 1
                                        ? (currentItem?.basket_price + (currentItem?.basket_price * allKey?.gst) / 100)
                                        : currentItem?.basket_price
                                    )?.toFixed(2)}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {allKey?.officepaymenystatus === 1 && activeTab === "offline" && (
                <div className="row justify-content-center">
                    <div className="col-md-6">
                        <div className="card">
                            <div className="card-body text-center">
                                {qrdata.length > 0 &&
                                    qrdata.map((item, index) => {
                                        return (
                                            <div key={index} className="text-center">
                                                <h4 className=" fs-5 card-title btn-primary py-2 text-dark">Scan to Pay</h4>
                                                <img
                                                    src={item?.image}
                                                    alt="QR Code"
                                                    title="QR Code"
                                                    className="img-fluid mb-3"
                                                    style={{ width: 200, height: 200 }}
                                                />
                                            </div>
                                        );
                                    })}

                                {bankdetail?.map((item) => {
                                    return (
                                        <>
                                            <h4 className="btn-primary py-2 text-dark fs-5">Bank Details:</h4>
                                            <ul className="ps-0">
                                                <li className="list-group-item d-flex justify-content-between"> <b>Account Name:</b> {item?.name} </li>
                                                <li className="list-group-item d-flex justify-content-between">  <b>Account Number:</b> {item?.accountno}</li>
                                                <li className="list-group-item d-flex justify-content-between">  <b>IFSC Code:</b> {item?.ifsc}</li>
                                                <li className="list-group-item d-flex justify-content-between">  <b>Branch Name :</b> {item?.branch}</li>
                                            </ul>
                                        </>
                                    )
                                })}
                            </div>
                        </div>
                    </div>
                </div>
            )}

            <ReusableModal
                show={viewmodel2}
                onClose={() => setViewModel2(false)}
                title={<>KYC</>}
                body={
                    <Kyc
                        onSuccess={() => {
                            setViewModel2(false);
                        }}
                        type="payment"
                        kyckey={kyckey}
                    />
                }
                size="lg"
            />

            <ReusableModal1
                show={viewmodel3}
                onClose={() => setViewModel3(false)}
                title={<>KYC</>}
                body={
                    <Kyc
                        onSuccess={() => {
                            setViewModel3(false);
                        }}


                    />
                }
                disableClose={false}
                size="lg"
            />
        </Content>
    );
};

export default Payments;